import { Theme } from "@mui/material";

export const borders = (theme: Theme) =>
  `1px solid ${theme.palette.background.highlighter}`;

export const dividerStyles = (theme: Theme) => ({
  content: `""`,
  position: "absolute",
  display: "flex",
  width: 1,
  background: theme.palette.background.highlighter,
  top: 8,
  bottom: 8,
  right: 0,
  transform: "translateX(50%)",
  zIndex: 1,
});
